export const title =
  "Pitchontbijt Vlaanderen: Innovatie, Adaptiviteit en Samenwerking";

export const sections = [
  {
    content:
      "DD-Group was 25 juni jl. de trotse host van het iTanks Pitchontbijt in Vlaanderen. Tijdens onze keynote belichtten we thema’s als geopolitieke onzekerheid, handelsbelemmeringen, cybercriminaliteit, strengere regelgeving rondom schijnzelfstandigheid en de krapte op de arbeidsmarkt. Hoe kun je omgaan met deze complexe vraagstukken, deze kleiner maken en een eerste stap zetten naar adaptiviteit van je organisatie om met dit soort vraagstukken om te gaan. Daarnaast waren er innovatieve pitches van onze samenwerkingspartners die hier verband mee hadden. En dat alles op een prachtige locatie: De Blauwe Hoeve in Zwijndrecht, België! ",
    image: "/assets/images/blogs/pitchontbijt-blauwehoeve.jpg",
  },
  {
    image: "/assets/images/blogs/pitchontbijt-blauwehoeve2.jpg",
  },
];
